import React from 'react';
import { Text } from 'rebass';
import {
  FormField,
  ValidationStatus,
} from '@ecosconnect/core/src/helpers/backflow/form-builder';

// Renders a field's validation message (warnings and failure details) under
// its input row.
const FieldMessage: React.FC<{ field?: FormField<any, any> }> = ({ field }) => {
  if (!field?.message || field.status === ValidationStatus.HIDE) {
    return null;
  }
  return (
    <Text
      variant="validation"
      textAlign="right"
      color={
        field.status === ValidationStatus.WARN ? 'statusWarning' : undefined
      }
    >
      {field.message}
    </Text>
  );
};

export default FieldMessage;
